import { PaginationResponse } from "models/pagination-response";
import { IConselhoPagedRequest } from "models/request/conselho-paged-request";
import { IConselhoPagedResponse } from "models/response/conselho-paged-response";
import { IAreaTransparenciaSetorialResponse } from "models/response/area-transparencia-setorial-response";

export type ConselhosState = {
    conselhos: PaginationResponse<IConselhoPagedResponse>;
    conselhoPagedRequest: IConselhoPagedRequest;
    areas: IAreaTransparenciaSetorialResponse[];
    ultimaAtualizacao: string | null;
    loading: boolean;
    error: string | null;
};

export enum ACTION_TYPES {
    setConselhos = 'setConselhos',
    setConselhoPagedRequest = 'setConselhoPagedRequest',
    setAreas = 'setAreas',
    setUltimaAtualizacao = 'setUltimaAtualizacao',
    setLoading = 'setLoading',
    setError = 'setError',
}

export const ConselhosReducer = (state: ConselhosState, action: any): ConselhosState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.setConselhoPagedRequest:
            return { ...state, conselhoPagedRequest: payload };
        case ACTION_TYPES.setConselhos:
            return { ...state, conselhos: payload };
        case ACTION_TYPES.setAreas:
            return { ...state, areas: payload };
        case ACTION_TYPES.setUltimaAtualizacao:
            return { ...state, ultimaAtualizacao: payload };
        case ACTION_TYPES.setLoading:
            return { ...state, loading: payload };
        case ACTION_TYPES.setError:
            return { ...state, error: payload };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
}
